module.exports = require("./ug.d.ts");